/* LOGS */
export const GET_LOGS = "GET_LOGS"
export const GET_LOGS_SUCCESS = "GET_LOGS_SUCCESS"
export const GET_LOGS_FAIL = "GET_LOGS_FAIL"